import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { EditActions, editActions } from "../../../../actions/editActions";
import MenuButton from "../../../../components/MenuButton/MenuButton";
import Table from "../../../../components/Table/Table";
import { ioConfigActions } from "../../../../actions/ioConfigActions";
import { NavLink } from "react-router-dom";
import { hasWriteAccess } from "../../../../utils/utils";
import add from "../../../../images/circle-plus.svg";
import styles from "../../../../components/MenuButton/MenuButton.module.scss";

type StateProps = {
  columns: State.ColumnMap;
  mainState: State.Main;
  ioConfigurations: Api.IoConfiguration[] | undefined;
};

type DispatchProps = {
  editActions: typeof editActions;
  ioConfigActions: typeof ioConfigActions;
};

type OwnProps = {
  // eslint-disable-next-line @typescript-eslint/ban-types
  onIoConfigurationClick: Function;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onAddIoConfigurationClick: Function;
  // eslint-disable-next-line @typescript-eslint/ban-types
  isLoadingConfigurations: boolean;
};

// Props of the component
export type SelectConfigurationProps = StateProps & DispatchProps & OwnProps;

const SelectConfiguration = (props: SelectConfigurationProps) => {
  const {
    ioConfigurations,
    columns,
    mainState,
    onIoConfigurationClick,
    onAddIoConfigurationClick,
    isLoadingConfigurations
  } = props;

  const selectedColumns = columns["IO Configurations"];

  return (
    <div className="io-wrapper">
      <div className="io-header">
        <h2>Select configuration</h2>
        <div className="io-actions">
          {hasWriteAccess(mainState.activeUser, "Lift") ? (
            <MenuButton
              type="Add"
              customText="Add IO configuration"
              handleOnClick={() => onAddIoConfigurationClick()}
            />
          ) : (
            <div className={styles.MenuButtonWrapper}>
              <img src={add} className={`${styles.icon} ${styles.disableImg}`} alt="Add" />
              <span className={styles.disableText}>Add IO configuration</span>
            </div>
          )}
          <NavLink to="/tools/open-binary-config-file/">
            <MenuButton
              type="Open"
              customText="Open binary config file"
              handleOnClick={() => {
                /*  */
              }}
            />
          </NavLink>
          <NavLink to="/tools/standard-boards">
            <MenuButton
              type="Edit"
              customText="Edit Standard Boards"
              handleOnClick={() => {
                /*  */
              }}
            />
          </NavLink>
        </div>
      </div>
      <div className="io-content-wrapper">
        <Table
          rows={ioConfigurations || []}
          loading={isLoadingConfigurations}
          loadingText="Fetching Io Configurations..."
          columns={selectedColumns}
          isHidingTextActive={false}
          handleRowSelection={item => onIoConfigurationClick(item.id)}
          isRowSelected={() => false}
          pageSize={mainState.pageSize}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state: State.Root) => ({
  columns: state.columns,
  mainState: state.main,
  ioConfigurations: state.ioConfig.ioConfigurations
});

const mapDispatchToProps = (dispatch: Dispatch<EditActions>) => ({
  editActions: bindActionCreators({ ...editActions }, dispatch),
  ioConfigActions: bindActionCreators({ ...ioConfigActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectConfiguration);
